import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import CreateIcon from '@material-ui/icons/Create';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import ShowFiles from '../updateGrRecord/ShowFiles';
import {
  presentDate,
  presentFormatedData,
} from '../functionalComponents/dataFormatFunctions';
import { useSelector } from 'react-redux';
import DropFilesAttach from './files/DropFilesAttach';
const useStyles = makeStyles((theme) => ({
  title: {
    fontWeight: 500,
    fontSize: '1.5rem',
    textAlign: 'left',
    paddingBottom: '0.3rem',
  },
  font: {
    fontWeight: 500,
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
  },
  fontPadding: {
    // padding: '0.5rem 0.5rem 0.5rem 0rem',
    textAlign: 'initial',
    overflow: 'auto',
  },
  files: {
    boder: '1px solid #707070',
    backgroundColor: '#F7F7F7',
    textAlign: 'center',
    padding: '2rem',
    cursor: 'pointer',
  },
  closeText: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    color: 'blue',
    textDecoration: 'underline',
  },
  document: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    backgroundColor: 'transparent',
    textAlign: 'end',
    paddingTop: '1rem',
  },
  borders: {
    border: '2px solid #707070',
    display: 'flex',
    width: '1.6rem',
    backgroundColor: 'grey',
  },
  grid: {
    paddingBottom: '2rem',
    paddingTop: '1rem',
    paddingRight: '1.5rem',
  },
  fileIcon: {
    cursor: 'pointer',
    textAlign: 'end',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
}));

export default function ChallanInfo(props) {
  const classes = useStyles();
  // const { challanInformation, handleOpenDialog } = props;
  const { handleOpenDialog, isAddRecord, challanInformation } = props;
  const { challanDate, challanNumber, ewayBillNumber, ewayBillDate } =
    props.challanInformation;
  const [challanFiles, setChallanFiles] = React.useState(
    challanInformation.challanFiles
  );

  const ewayBillEnabled = useSelector((state) => {
    if (state.pcmp.common.reports.rmpmGrnFeatures?.status) {
      return state.pcmp.common.reports.rmpmGrnFeatures.data.features
        .ewayBillEnabled;
    }
    return false;
  });

  const handlingDeleteFile = (i) => {
    // for rec fromBE=> mfd as 1, for local filter out
    //check for filetype in file
    //if 'buffer' then follow filter logic
    // if it is not buffer edit that file data sayn mfd 1
    if (challanFiles[i].grFileType === 'buffer') {
      let newdel = challanFiles.filter(
        (file) => file.grFileName !== challanFiles[i].grFileName
      );
      setChallanFiles(newdel);
    } else {
      // COAFiles[i].markForDelete=1;
      let markDelFile = challanFiles.map((file) =>
        file.grFileHash === challanFiles[i].grFileHash
          ? { ...file, markForDelete: true }
          : file
      );
      setChallanFiles(markDelFile);
    }
  };

  const FileHandling = (files) => {
    files.forEach((file) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onabort = () => console.error('file reading was aborted');
      reader.onerror = () => console.error('file reading has failed');
      reader.onload = () => {
        // Do whatever you want with the file contents
        const newArr = {
          grFileData: reader.result,
          grFileName: file.name,
          grFileType: 'buffer',
          schrockenGRFileId: '',
          grFileHash: '',
          markForDelete: false,
        };

        props.handlingFiles(newArr, 'challanFiles');
      };
    });
  };
  return (
    <React.Fragment>
      <Grid container className={classes.child}>
        <Grid item xs={8} sm={6} md={6} className={classes.grid}>
          <Typography variant='h4' className={classes.title}>
            Challan Information
          </Typography>
          <span className={classes.borders}></span>
        </Grid>

        {props.isEditExist === true ? (
          <Grid item xs={4} sm={6} md={6} className={classes.button}>
            <Button
              variant='contained'
              startIcon={<CreateIcon fontSize='small' />}
              style={{
                backgroundColor: 'transparent',
                boxShadow: 'none',
                border: '1px solid #000000de',
              }}
              size='small'
              onClick={() => handleOpenDialog('openChallan')}
            >
              Edit
            </Button>
          </Grid>
        ) : (
          <Grid item xs={4} sm={6} md={6}></Grid>
        )}

        <Grid item xs={12} sm={6} md={3} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Challan Number (optional)
          </Typography>

          <Typography variant='body2' className={classes.fontPadding}>
            {presentFormatedData(challanNumber, '-Not Provided-')}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={3} className={classes.grid}>
          <Typography variant='body2' className={classes.font}>
            Challan Date (optional)
          </Typography>
          <Typography variant='body2' className={classes.fontPadding}>
            {presentDate(challanDate, '-Not Provided-')}
          </Typography>
        </Grid>
        {ewayBillEnabled && (
          <React.Fragment>
            <Grid item xs={12} sm={6} md={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                E-way Bill Number (optional)
              </Typography>

              <Typography variant='body2' className={classes.fontPadding}>
                {presentFormatedData(ewayBillNumber, '-Not Provided-')}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} md={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                E-way Bill Date (optional)
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(ewayBillDate, '-Not Provided-')}
              </Typography>
            </Grid>
          </React.Fragment>
        )}

        {localStorage.collabType === 'CMO' && props.status === 3 && (
          <Grid container justify='center' style={{ paddingBottom: '2rem' }}>
            <Grid item xs={12} sm={12} md={12}>
              <DropFilesAttach
                title='Upload Challan (optional)'
                handleUploadFiles={FileHandling}
              />
            </Grid>
          </Grid>
        )}

        {!isAddRecord && (
          <Grid container className={classes.padding}>
            <Grid item xs={12} sm={6} md={6} style={{ paddingBottom: '1rem' }}>
              <Typography
                variant='body2'
                className={classes.font}
                style={{ paddingBottom: '0.5rem' }}
              >
                Uploaded Document List
              </Typography>

              <ShowFiles
                files={challanInformation.challanFiles}
                handlingDeleteFile={props.parentHandlingDeleteFile}
                name='challanFiles'
                isUploadFile={
                  props.status === 3 &&
                  localStorage.collabType === 'CMO' &&
                  true
                }
              />
            </Grid>
          </Grid>
        )}

        {isAddRecord && (
          <Grid container className={classes.padding}>
            <Grid item xs={12} sm={6} md={6}>
              <Typography variant='body2' className={classes.font}>
                Uploaded Document List
              </Typography>
              {challanFiles === undefined || challanFiles.length === 0 ? (
                <Typography
                  variant='body2'
                  className={classes.document}
                  style={{ paddingBottom: '2rem' }}
                >
                  -No Documents Uploaded-
                </Typography>
              ) : (
                <Typography variant='body2'>
                  {challanFiles.length !== 0
                    ? challanFiles.map((file, i) => {
                        return (
                          <span
                            key={i}
                            className={classes.closeText}
                            style={{ paddingBottom: '0.5rem' }}
                          >
                            {file.grFileName}{' '}
                            {localStorage.collabType === 'CMO' && (
                              <CloseIcon
                                fontSize='small'
                                color='error'
                                style={{ paddingLeft: '0.5rem' }}
                                onClick={() => handlingDeleteFile(i)}
                              />
                            )}
                            <br />
                          </span>
                        );
                      })
                    : ''}
                </Typography>
              )}
            </Grid>
          </Grid>
        )}
      </Grid>
    </React.Fragment>
  );
}
